import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const NoAttachments = () => /*#__PURE__*/_jsxs(Flex, {
  flexDirection: "column",
  gap: "200",
  flex: "1",
  alignItems: "center",
  justifyContent: "center",
  paddingInline: "400",
  children: [/*#__PURE__*/_jsx(Text, {
    typography: "heading-500",
    as: "h3",
    color: "text-core-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-portal-app.attachmentsPanel.noAttachments"
    })
  }), /*#__PURE__*/_jsx(Text, {
    typography: "body-100",
    as: "p",
    color: "text-core-default",
    textAlign: "center",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customer-portal-app.attachmentsPanel.noAttachmentsDescription"
    })
  })]
});